(function ($) {
	"use strict";

  
	/*=============================================
    =                Swiper Slider                =
    =============================================*/
    $('[hp-slider]').each(function () {
      var SwiperCarousel = $(this),
        getDataAttr = function(attr, defaultValue) {
          var value = SwiperCarousel.data(attr);
          return (value !== undefined && value !== null) ? value : defaultValue;
        },
        // Check if autoplay is enabled and configure accordingly
        autoplayConfig = getDataAttr('autoplay', false) ? { delay: 5000 } : false,
        swiperConfig = {
          slidesPerView: getDataAttr('items', 1),
          loop: getDataAttr('loop', true),
          speed: getDataAttr('speed', 600),
          lazy: getDataAttr('lazy', true),
          spaceBetween: parseInt(getDataAttr('space-between', 20)),
          navigation: {
            nextEl: SwiperCarousel.data('next'),
            prevEl: SwiperCarousel.data('prev'),
          },
          fadeEffect: { crossFade: true },
          autoplay: autoplayConfig,
          breakpoints: {
            480: {
              slidesPerView: getDataAttr('sm-items', 1),
              loop: getDataAttr('sm-loop', true),
              autoplay: getDataAttr('sm-autoplay', false) ? { delay: 5000 } : false,
              spaceBetween: parseInt(getDataAttr('sm-space-between', 20)),
            },
            750: {
              slidesPerView: getDataAttr('md-items', 1),
              loop: getDataAttr('md-loop', true),
              autoplay: getDataAttr('md-autoplay', false) ? { delay: 5000 } : false,
              spaceBetween: parseInt(getDataAttr('md-space-between', 20)),
            },
            991: {
              slidesPerView: getDataAttr('lg-items', 1),
              loop: getDataAttr('lg-loop', true),
              autoplay: getDataAttr('lg-autoplay', false) ? { delay: 5000 } : false,
              spaceBetween: parseInt(getDataAttr('lg-space-between', 20)),
            },
          },
        };
    
      new Swiper(SwiperCarousel[0], swiperConfig);
    });

      
    // Click event for Tab Heading
    $(".hp-tab-link").click(function(e) {
      e.preventDefault();
      alert(1);
    
      // Reference to the clicked element
      var $this = $(this);
    
      // Remove "active" class from all panels and links within the same tab wrapper
      $this.closest('.tab--wrapper').find('.hp-tab__panel').removeClass("active");
      $this.closest('.tab--wrapper').find('.hp-tab-link').removeClass("active");
    
      // Toggle the "active" class for the clicked tab link
      $this.toggleClass("active");
    
      // Toggle the "active" class for the corresponding tab panel
      var targetPanel = $($this.attr("href"));
      targetPanel.toggleClass("active");
    });


    // ADD TO CART
    $(document).ready(function () {
      $("body").on("click", "[product-add-to-cart]", async function (e) {
          e.preventDefault();
  
          const Button = $(this).find('button[type="submit"]');
          if (Button.length){
            Button.prop("disabled", true).text("Adding...");            
          };
  
          const ProductVariant = $(this).attr("data-variant"),
                ProductType = $(this).attr("data-type"),
                FormData = { items: [{ id: ProductVariant, quantity: 1 }] };
  
          try {
              const CartData = await (await fetch(window.Shopify.routes.root + "cart.js")).json();
              let GrassSamples = CartData.items.filter(i => i.product_type === "Grass Samples");
              // Calculate total count (sum of quantities)
              let TotalGrassCount = GrassSamples.reduce((total, item) => total + item.quantity, 0);

              if (ProductType === "Grass Samples" && TotalGrassCount >= 3) {
                  alert("You can only add up to 3 'Grass Samples' per order.");
                  for (let Item of GrassSamples.slice(3)) {
                      await fetch(window.Shopify.routes.root + "cart/change.js", {
                          method: "POST", headers: { "Content-Type": "application/json" },
                          body: JSON.stringify({ id: Item.key, quantity: 0 }),
                      });
                  }
                  return;
              } 
              const newres = await fetch(window.Shopify.routes.root + "cart/add.js", {
                  method: "POST", headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(FormData),
              });
              window.location.href = "/cart";
            console.log("CartData", CartData);
            console.log("GrassSamples", GrassSamples);
          } catch (Err) {
              alert(Err.message);
              console.error("Error:", Err);
          } finally {
            if (Button.length){
              Button.prop("disabled", false).text("Get your Sample");     
            };
          }
      });
  });






  
})(jQuery);


document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.scroll-down--location').forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();

            const href = this.getAttribute('href');
            const targetId = href.includes('#') ? href.split('#')[1] : null;

            if (targetId) {
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    const offsetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 100;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth',
                    });
                } else {
                    // Redirect to the link if target is not found
                    window.location.href = href;
                }
            }
        });
    });

  
    // ADD TO CART
    document.querySelectorAll(".cart-add--sample[data-variant]").forEach(Button => {
        Button.addEventListener("click", async function (e) {
            e.preventDefault();
    
            if (Button) {
                Button.disabled = true;
                Button.textContent = "Adding...";
            }
    
            const ProductVariant = Button.getAttribute("data-variant"),
                  ProductType = Button.getAttribute("data-type"),
                  FormData = { items: [{ id: ProductVariant, quantity: 1 }] };
    
            try {
                const CartData = await (await fetch(window.Shopify.routes.root + "cart.js")).json();
                let GrassSamples = CartData.items.filter(i => i.product_type === "Grass Samples");
                // Calculate total count (sum of quantities)
                let TotalGrassCount = GrassSamples.reduce((total, item) => total + item.quantity, 0);
  
                if (ProductType === "Grass Samples" && TotalGrassCount >= 3) {
                    alert("You can only add up to 3 'Grass Samples' per order.");
                    if (Button.length){
                      Button.prop("disabled", false).text("Get your Sample");     
                    };
    
                    for (let Item of GrassSamples.slice(3)) {
                        await fetch(window.Shopify.routes.root + "cart/change.js", {
                            method: "POST", headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ id: Item.key, quantity: 0 }),
                        });
                    }
                    return;
                } 
                await fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST", headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(FormData),
                });
    
                window.location.href = "/cart";
            } catch (Err) {
                alert(Err.message);
                console.error("Error:", Err);
            } finally {
                if (Button) {
                    Button.disabled = false;
                    Button.textContent = "Get a Sample";
                }
            }
        });
    });

}); // Close DOMCo

